import { atom } from 'recoil';

// color picker :https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=FFD54F&secondary.color=37474F

export const themeState = atom({
	key: 'themeState',
	default: {
		palette: {
			type: 'light',
			primary: {
				main: '#b71c1c',
			},
			secondary: {
				main: '#212121',
			},
		},
	},
});
